import { render } from "./paragraphColl.vue?vue&type=template&id=cc341b4a&scoped=true"
import script from "./paragraphColl.vue?vue&type=script&lang=js"
export * from "./paragraphColl.vue?vue&type=script&lang=js"

import "./paragraphColl.vue?vue&type=style&index=0&id=cc341b4a&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc341b4a"]])

export default __exports__